const it = {
    SHOP_GENERAL: {
        CAMPI_COMUNI:()=> <>
            In questa sezione si indicano alcune proprietà condivise a tutti i tipi di Shop. Le proprietà sono le seguenti:
            <li><strong>Nome</strong> (obbligatorio) - Il nome che desideri dare al tuo shop; dev'essere lungo tra i 3 e i 100 caratteri.</li>
            <li><strong>Customer code</strong> (obbligatorio) - E' il codice che identifica il tuo shop; dev'essere lungo tra i 3 e i 100 caratteri.</li>
            <li><strong>Default currency</strong> (facoltativo) - E' la currency di default per il tuo shop.</li>
        </>,
        FLUSSI_LISTING:()=> <>
            In questa sezione puoi abilitare o disabilitare i flussi e i tipi di listing disponibili a questo tipo di shop.
        </>,
        STRATEGIA_MAGAZZINI:()=> <>
            <p>In questa sezione è possibile scegliere se, relativamente alla <strong>strategia di gestione dei magazzini</strong>, il tuo shop usa la <strong>configurazione predefinita per il tuo account</strong> oppure ne usa una <strong>personalizzata.</strong></p>
            <p>Se scegli di usarne una <strong>personalizzata</strong>, potrai scegliere dal menù a tendina quale applicare al tuo shop.</p>
        </>
    },
    SHOP_WINKLESTRAAT: {
        X_API_KEY:()=> <p>Questa chiave verrà generata in fase di creazione, e sarà possibile copiarla da qui o dalla lista degli shops. E' possibile anche rigenerarlo tramite apposito pulsante presente nella parte destra del campo di testo. È usato da Winkelstraat per l’accesso ai Webhooks elencati di seguito.</p>,
        WEBHOOKS: {
            SHIPMENT:()=> <p>Questo endpoint sarà disponibile e copiabile dopo la creazione dello shop.</p>,
            SHIPMENT_TRACK:()=> <p>Questo endpoint sarà disponibile e copiabile dopo la creazione dello shop.</p>,
            RMA_ITEMS:()=> <p>Questo endpoint sarà disponibile e copiabile dopo la creazione dello shop.</p>
        }
    },
    SHOP_FARFETCH:{
        MERCHANT_CODE:()=><p>Merchant Code</p>,
        MERCHANT_CODE_INFO:()=><p>La modifica di questo campo dev’essere concordata con il Success Partner di Farfetch. Successivamente contattare il supporto di CloudStore.</p>,
        REST_API_INFO: ()=><>
            <p>Questa sezione ti permette di configurare i parametri per le connessioni REST.</p>
            <p>Se il <strong>Business Model</strong> è impostato su <strong>Bid / Ask</strong>, allora è <strong>obbligatorio</strong> compilare questa sezione in tutti i suoi campi.</p>
            <p>Altrimenti si può lasciare vuoto, a patto di non compilare nessuno dei campi qui sotto elencati.</p>
        </>,
    }
}

export default it